import { useChatStore } from '@/stores/chat'
import { useUsersStore } from '@/stores/users'
import { useChatAttendance } from '@/stores/chat/attendances'
import { sendWebSocketMessage } from '@/composables/chat/useWebSocket'
import { useChatMessages } from '@/stores/chat/messages'
import audioFile from '@/assets/audio/notification.ogg'
import { useFavicon } from '@vueuse/core'

import IconNewAttendance from '@/assets/images/icons/IconNewAttendance.svg'
import logo_compact from '@/assets/images/logos/logo_compact.svg'


const store = useChatAttendance()
const userStore = useUsersStore
const chatStore = useChatStore()
const storeMessages = useChatMessages()
/**
 * @param {Object} attendance
 * @param {Boolean} checkToRemove
 */


 

export const transferedAttendance = (attendance) => {

 
     const isAdmin = userStore().isAdmin;
    const chat_step = attendance.chat_step

    // Limpa o atendimento de todas as listas antes de re-adicionar na posição correta
    const allLists = [store().progress, store().waiting, store().automation, store().audit.progress, store().audit.waiting]
    for (const list of allLists) {
        if (!Array.isArray(list)) continue
        const idx = list.findIndex(item => item.id === attendance.id)
        if (idx !== -1) list.splice(idx, 1)
    }
  
    // regra 1 se for Admin ou estiver no transfered_to adiciona no waiting do audit
    if(isAdmin || attendance.transfered_to.includes(userStore().me?.id)){

        //se não existir um atendente atribuído adiciona em waiting
        if(!attendance.user_id){
            const existingItem = store().audit.waiting.find(existing => existing.id === attendance.id);
            if (!existingItem) {

            store().audit.waiting.unshift(attendance)
            }
        //se existir atendente adiciona no progress
        } else {
            const existingItem = store().audit.progress.find(existing => existing.id === attendance.id);
            if (!existingItem) {
                store().audit.progress.unshift(attendance)

                if(chatStore().soundAlert){

                    var audio = new Audio(audioFile);
                    audio.play();
                     
                }
            }
        }
    }
    // regra 2 se estiver no transfered_to adiciona no waiting do atendente
   
        if(attendance.transfered_to.includes(userStore().me?.id)){ //&& attendance.user_id !== Number(userStore().me?.id)){

            //verifica se não existe user_id (não foi atribuído)
            if(!attendance.user_id){
                //verifica se já não existe o atendimento na etapa waiting antes de fazer o push
                const existingItem = store().waiting.find(existing => existing.id === attendance.id);
                if (!existingItem) {
                    store().waiting.unshift(attendance)
                    if(chatStore().soundAlert){

                        var audio = new Audio(audioFile);
                        audio.play();
                         
                    }
                }

            } else {

                if(attendance.user_id == userStore().me?.id){
                    const existingItem = store().progress.find(existing => existing.id === attendance.id);
                    if (!existingItem) {
                        store().progress.unshift(attendance)
                        storeMessages().requestMessages(attendance.id)
                        if(chatStore().soundAlert){

                            var audio = new Audio(audioFile);
                            audio.play();
                             
                        }
                    }
                }
            }
            
    // regra 3 se não estiver no transfered_to remove do waiting do atendente 
        } else {
   
            const findIndex = store().waiting.findIndex(item => item.id === attendance.id)
            if(findIndex !== -1){
                 store().waiting.splice(store().waiting.findIndex(item => item.id === attendance.id), 1)
            }
        }
       
    

    if(attendance.automation.action){
        //regra 4 se o atendimento vier da automação, removê-lo da automação
        if(['assign', 'closed', 'return_automation','automation_transfer','timeout_business','timeout_client','finish_action','transfer_direct'].includes(attendance.automation.action)){
            const autoIdx = store().automation.findIndex(item => item.id === attendance.id)
            if (autoIdx !== -1) {
                store().automation.splice(autoIdx, 1)
            }
        }

        if(attendance.automation.action == 'transfer_direct' && attendance.user_id == userStore().me?.id){

            const existingItem = store().progress.find(existing => existing.id === attendance.id);
            if (!existingItem) {
    
                store().progress.unshift(attendance)
                storeMessages().requestMessages(attendance.id)

            }

        }

    }
 

}

export const newAttendance = (attendance, checkToRemove = false, action = '') => {

   
   //Se não for admin e não estiver no transfered_to ou no user id remove o atendimento
    /*  if(!userStore().isAdmin && (!attendance?.transfered_to.includes(userStore().me?.id) && attendance?.user_id !== Number(userStore().me?.id))){
        let steps = ['waiting'].filter(step => step !== attendance.chat_step)
        removeAttendance(attendance.id, steps)
    } */
   
    //Se o atendimento estiver com o step waiting e o usuário atual não existir no transfered_to nem no user_id, remover do waiting
   /* if(attendance.transfered_to.length){
        if(!attendance.transfered_to.includes(userStore().me?.id)){ //&& attendance.user_id !== Number(userStore().me?.id)){
            console.log(`O atendimento foi removido do waiting porque o usuário atual (${userStore().me?.id}) não existe no transfered_to nem no user_id`, attendance)
            store().waiting.splice(store().waiting.findIndex(item => item.id === attendance.id), 1)
        }
    } */


    if(chatStore().soundAlert){

        if(attendance.user_id == userStore().me?.id || attendance?.transfered_to.includes(userStore().me?.id)|| attendance.chat_step == 'waiting'){
            var audio = new Audio(audioFile);
            audio.play();
        }
    }

    if(attendance.user_id == userStore().me?.id || attendance?.transfered_to.includes(userStore().me?.id)){

        let interval
        if(!chatStore().focused){
            var current = 0;
            var icons = [IconNewAttendance, logo_compact];

            interval = setInterval(() => {
                var icon = (++current % icons.length);
                var url = icons[icon];

                useFavicon(url)
            }, 500);
        }

        setInterval(()=>{

            if(chatStore().focused){
                clearInterval(interval)
                useFavicon(logo_compact)
            }

        }, 1)

    }


    if (!attendance.last_message?.timestamp) {
        console.log('Timestamp não está vindo do BACK', attendance, 'action', action)
        if (!attendance.last_message) attendance.last_message = {}
        attendance.last_message.timestamp = new Date().getTime()
    }

    const attendanceStep = attendance?.chat_step.replace('active', 'progress')
    if (!attendanceStep) {
        console.error('[chat] newAttendance: chat_step is not defined', attendance)
        return
    }

    const attendanceId = Number(attendance?.id)

    if (checkToRemove) {
        let steps = ['progress', 'waiting', 'automation'].filter(step => step !== attendanceStep)

        removeAttendance(attendanceId, steps)
    }
 
    let attendanceList = store()[attendanceStep] 
 
        if (
            ['progress', 'waiting'].includes(attendanceStep) &&
            !attendance?.transfered_to.includes(userStore().me?.id) &&
            //attendance?.user_id !== null &&
            attendance?.user_id !== Number(userStore().me?.id) 
        ) {
            attendanceList = store().audit[attendanceStep]
        }
   
    // Check exists attendance in list using ID
    const attendanceIndex = attendanceList.findIndex(item => item.id === attendanceId)
    if (attendanceIndex !== -1) {
        return
    }

    attendanceList.unshift(attendance)
     
    
  }

/**
 * Atualiza as tags do atendimento e do cliente a partir do evento attendance_updated.
 *
 * @param {Object} attendance
 * @returns {void}
 */
export const updateAttendanceTags = (attendance) => {
    if (!attendance) return

    const attendanceId = Number(attendance?.id)
    if (!attendanceId) return

    const attendanceInStore = store().getAttendance(attendanceId, ['progress', 'waiting', 'automation'])
    if (!attendanceInStore) return

    attendanceInStore.tags = attendance?.tags ?? []

    if (attendanceInStore.client) {
        attendanceInStore.client.tags = attendance?.client?.tags ?? []
    }
}

/**
 * Normaliza uma tag de cliente para o formato flat (bg_color/text_color),
 * aceitando tanto o shape do CRUD (ClientTagResource) quanto o shape do job
 * de automação (ClientTags com a tag aninhada em `tag`).
 *
 * @param {Object} tag
 * @returns {Object|null}
 */
const normalizeClientTag = (tag) => {
    if (!tag || typeof tag !== 'object') return tag

    if (tag.tag && typeof tag.tag === 'object') {
        return {
            id: tag.tag.id ?? tag.tag_id,
            name: tag.tag.name,
            description: tag.tag.description,
            bg_color: tag.tag.bg_color,
            text_color: tag.tag.text_color,
            created_at: tag.created_at ?? tag.tag.created_at,
            expiration_at: tag.expiration_at ?? tag.tag.expiration_at,
            created_by: tag.created_by ?? null,
        }
    }

    return tag
}

/**
 * Sincroniza as tags de um cliente em todos os atendimentos abertos (listas e
 * atual) a partir do evento sync_client_tags.
 *
 * @param {Object} data { client_id, tags }
 * @returns {void}
 */
export const syncClientTags = (data) => {
    if (!data) return

    const clientId = Number(data?.client_id)
    if (!clientId) return

    const tags = (Array.isArray(data?.tags) ? data.tags : []).map(normalizeClientTag)

    const apply = (attendance) => {
        if (attendance?.client && Number(attendance.client.id) === clientId) {
            attendance.client.tags = tags
        }
    }

    const lists = [
        store().progress,
        store().waiting,
        store().automation,
        store().audit?.progress,
        store().audit?.waiting,
    ]

    lists.forEach((list) => {
        if (!Array.isArray(list)) return
        list.forEach(apply)
    })

    const current = store().currentAttendance
    if (current?.client && Number(current.client.id) === clientId) {
        current.client.tags = tags
    }
}

/**
 * @param {Number} attendanceId
 * @param {String} attendanceStep
 * @param {Object} lastMessage
 */
export const updateLastMessage = (attendanceId, attendanceStep, lastMessage) => {
    const lastMessageContent = prepareContentToLastMessage(lastMessage.type, lastMessage.content.type, lastMessage.content.content)

   
    if (!lastMessage.timestamp) { 
        console.log('Timestamp não presente no lastMessage', attendanceId, lastMessage)
        lastMessage.timestamp = Number(new Date().getTime().toString().slice(0, 10))
    }

    let attendance = store().getAttendance(attendanceId, [attendanceStep])
    if (!attendance) {
        const checkInSteps = ['progress', 'waiting', 'automation']

        attendance = store().getAttendance(attendanceId, checkInSteps)
        if (
            !userStore().isAdmin ||
            userStore().isAdmin && !attendance
        ) {
            removeAttendance(attendanceId, checkInSteps)
           /* console.error(
                `[chat] updateLastMessage: attendance not found in step: ${attendanceStep}. Find attendance in all steps and remove.`,
                attendanceId,
                attendanceStep,
            ) */
            return
        }

        removeAttendance(attendanceId, checkInSteps)

        if(attendanceStep){
            store().audit[attendanceStep].unshift(attendance)
            
        }

    }

  
    attendance.last_interaction = lastMessage.type == "received" ? 'client' : 'business'
    attendance.last_message = {
        id: lastMessage.id,
        direction: lastMessage.type,
        type: lastMessage.content.type,
        ack: lastMessage.ack,
        content: lastMessageContent,
        timestamp: lastMessage.timestamp,
        uuid: lastMessage.uuid,
    }
}

export const assignAttendance = (ignore, by_audit) => {
    const attendance = store().currentAttendance
   
   
    if (!attendance?.id) {
        console.error('[chat] assignAttendance: attendance not found', attendance)
        return
    }

    const user = userStore().me
 

    const payloadAssign = {
        'type': 'chat',
        'action': 'assign',
        'data': { 'attendance_id': attendance?.id, 'user_id': user.id, 'ignore_automatic_message': ignore, by_audit: by_audit },
    }
    sendWebSocketMessage(payloadAssign)

    attendance.chat_step = 'progress'
    attendance.user_id = user.id
    attendance.transfered_to = []
    newAttendance(attendance, true, 'assignAttendance')
    storeMessages().requestMessages(attendance.id)
    store().$router.push({ name: 'chat.attendances.progress', params: { id: attendance.id } })

    setTimeout(() => {
        sendWebSocketMessage({
            'type': 'chat',
            'action': 'remove_attendance',
            'data': { 'attendance_id': attendance?.id, 'user_action': user.id, 'action': 'assign' },
            'to_user': chatStore().toAllWithoutMe(user.id),
        })
    }, 100)

    setTimeout(() => {
        chatStore().toUsers?.audit.push(user.id)
        sendWebSocketMessage({
            'type': 'chat',
            'action': 'audit_attendance',
            'data': { 'attendance_id': attendance?.id, 'user_id': user.id },
            'to_user': chatStore().toUsers?.audit,
        })
    }, 200)


}

/**
 * @param {Object} attendance
 * @param {String} description
 * @param {Boolean} satisfaction
 * @param {Boolean} send_message
 * @param {Number|null} survey_id
 * @param {Number|null} restart_automation_id
 */
export const closeAttendance = (attendanceId, description, satisfaction, send_message, survey_id, restart_automation_id = null) => {

    const user = userStore().me

    const payload = {
        'type': 'chat',
        'action': 'close',
        'data': {
            'attendance_id': attendanceId,
            'satisfaction_id': survey_id || null,
            'reason': '',
            'description': description,
            'satisfaction': satisfaction,
            'send_message': send_message,
            'restart_automation_id': restart_automation_id || null,
            'requested': user.id,
        },
    }  
 
    sendWebSocketMessage(payload)
   
    setTimeout(() => {
        sendWebSocketMessage({
            'type': 'chat',
            'action': 'remove_attendance',
            'data': { 'attendance_id': attendanceId, 'user_action': user.id, 'action': 'closed' },
            'to_user': chatStore().toUsers.all,
        })
    }, 100)

    

}


/**
 * @param {Number} attendanceId
 * @param {String} attendanceStep
 * @param {String} action
 */


/**
 * Closes an attendance.
 *
 * @param {string} attendanceId - The ID of the attendance to be closed.
 * @param {string} [attendanceStep=''] - The current step of the attendance.
 * @param {string} [action=''] - The action to be performed on the attendance.
 * @returns {void}
 */
export const closedAttendance = (attendanceId, attendanceStep = '', action = '') => {
    let checkInSteps = [attendanceStep]
    const forceRemove = ['assign', 'closed', 'return_automation','timeout_business','timeout_client','finish_action']

    if (action.length > 0 && forceRemove.includes(action)) {
        // Remove forced attendance
        checkInSteps = ['progress', 'waiting', 'automation']
    }

    if (checkInSteps[0].length === 0) return

    // TODO: entender o motivo de fechar o modal ---->>>> useChat.data.modal.show = false
    removeAttendance(attendanceId, checkInSteps)

}

// PRIVATE FUNCTIONS

/**
 * @param {String} type
 * @param {String} typeMessage
 * @param {String} message
 * @return {String}
 */
const prepareContentToLastMessage = (type, typeMessage, message) => {
    if (typeMessage === 'text') return message

    const acceptMessageTypes = {
        image: 'uma imagem',
        video: 'um vídeo',
        audio: 'um áudio',
        file: 'um arquivo',
        contact: 'um contato',
        document: 'um documento',
    }
    const complementMessage = acceptMessageTypes[typeMessage] || 'mensagem'

    type = type === 'received' ? 'recebeu' : 'enviou'

    return `Você ${type} ${complementMessage}.`
}

/**
 * @param {Number} attendanceId
 * @param {String[]} checkInSteps
 */
const removeAttendance = (attendanceId, checkInSteps = ['progress', 'waiting', 'automation']) => {
    const acceptedSteps = ['progress', 'waiting', 'automation']
    if (!checkInSteps.every(step => acceptedSteps.includes(step))) {
        // console.error('[chat] removeAttendance: checkInSteps is not valid', checkInSteps)
        return
    }

    let attendancePath = store().getAttendance(attendanceId, checkInSteps, true)
    if (!attendancePath) {
        // console.error('[chat] removeAttendance: attendance not found', attendanceId, checkInSteps)
        return
    }

    //chatStore().attendances.closed.push(attendancePath.findIndex(item => item.id === attendanceId))


    
    attendancePath.splice(attendancePath.findIndex(item => item.id === attendanceId), 1)
     

    attendancePath = store().getAttendance(attendanceId, checkInSteps, true)

 
    if (!attendancePath) {
        // console.error('[chat] removeAttendance: attendance not found', attendanceId, checkInSteps)
        return
    }

    //chatStore().attendances.closed.push(attendancePath.findIndex(item => item.id === attendanceId))

    attendancePath.splice(attendancePath.findIndex(item => item.id === attendanceId), 1)

  

      
}


export const updateEditedMessage = (attendanceId, messageId, messageContent) => {

    const messageIndex = storeMessages().currentMessages
        .findIndex(item => item.attendance_id === attendanceId && item.id === messageId)

    storeMessages().currentMessages[messageIndex].edited = true
    storeMessages().currentMessages[messageIndex].content.content = messageContent

}

export default {
    updateLastMessage,
    newAttendance,
    assignAttendance,
    closeAttendance,
    updateEditedMessage,
    syncClientTags,
}
